(function () {
  'use strict';

  var SWAP_SELECTORS = [
    '#product-grid',
    '[data-productgrid-sidebar-drawer]',
    '#ProductGridActiveFilters',
    '#ProductGridPagination',
    '#ProductGridFilterTrigger',
    '#ProductGridCount',
  ];
  var REQUEST_TIMEOUT_MS = 10000;

  function Controller(outer) {
    this.outer = outer;
    this.sidebarOpen = false;
    this.activeRequest = null;
    this.bodyOverflow = '';

    var form = outer.querySelector('facet-filters-form');
    if (!form || !form.dataset.sectionId) return;

    this.sectionId = form.dataset.sectionId;

    this.onClick = this.onClick.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onInput = this.onInput.bind(this);
    this.onPopState = this.onPopState.bind(this);
    this.onKeydown = this.onKeydown.bind(this);

    this.outer.addEventListener('click', this.onClick);
    this.outer.addEventListener('submit', this.onSubmit);
    this.outer.addEventListener('change', this.onChange);
    this.outer.addEventListener('input', this.onInput);
    document.addEventListener('keydown', this.onKeydown);
    window.addEventListener('popstate', this.onPopState);
  }

  Controller.prototype.onChange = function (event) {
    var select = event.target.closest ? event.target.closest('[data-productgrid-trigger-sort]') : null;
    if (select) {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      this.renderFilters(url.toString());
      return;
    }

    var slider = event.target.closest ? event.target.closest('[data-price-range-input]') : null;
    if (slider) {
      this.syncPriceRangeSlider(slider);
      var form = slider.closest('form');
      if (form) form.requestSubmit();
      return;
    }

    var numericSlider = event.target.closest ? event.target.closest('[data-numeric-range-input]') : null;
    if (numericSlider) {
      this.syncNumericRangeSlider(numericSlider);
      var numericForm = numericSlider.closest('form');
      if (numericForm) numericForm.requestSubmit();
      return;
    }

    var number = event.target.closest ? event.target.closest('[data-filter-range]') : null;
    if (number) this.syncPriceRangeFromNumber(number);
  };

  Controller.prototype.onInput = function (event) {
    var slider = event.target.closest ? event.target.closest('[data-price-range-input]') : null;
    if (slider) {
      this.syncPriceRangeSlider(slider);
      return;
    }

    var numericSlider = event.target.closest ? event.target.closest('[data-numeric-range-input]') : null;
    if (numericSlider) this.syncNumericRangeSlider(numericSlider);
  };

  Controller.prototype.syncPriceRangeSlider = function (slider) {
    var form = slider.closest('form');
    if (!form) return;

    var minSlider = form.querySelector('[data-price-range-input="min"]');
    var maxSlider = form.querySelector('[data-price-range-input="max"]');
    if (!minSlider || !maxSlider) return;

    var min = Number(minSlider.min);
    var max = Number(minSlider.max);
    var minVal = Number(minSlider.value);
    var maxVal = Number(maxSlider.value);

    if (slider === minSlider && minVal > maxVal) {
      minVal = maxVal;
      minSlider.value = minVal;
    } else if (slider === maxSlider && maxVal < minVal) {
      maxVal = minVal;
      maxSlider.value = maxVal;
    }

    var minNumber = form.querySelector('.collection-filters__filter-range--from [data-filter-range]');
    var maxNumber = form.querySelector('.collection-filters__filter-range--to [data-filter-range]');
    if (minNumber) minNumber.value = minVal;
    if (maxNumber) maxNumber.value = maxVal;

    var span = max - min;
    var fill = form.querySelector('[data-price-range-fill]');
    if (fill && span > 0) {
      fill.style.setProperty('--range-min-pct', ((minVal - min) / span) * 100 + '%');
      fill.style.setProperty('--range-max-pct', ((maxVal - min) / span) * 100 + '%');
    }

    var symbol = form.querySelector('.collection-filters__filter-range-currency');
    symbol = symbol ? symbol.textContent : '';
    var minLabel = form.querySelector('[data-price-range-label="min"]');
    var maxLabel = form.querySelector('[data-price-range-label="max"]');
    if (minLabel) minLabel.textContent = symbol + minVal;
    if (maxLabel) maxLabel.textContent = symbol + maxVal;
  };

  Controller.prototype.syncPriceRangeFromNumber = function (input) {
    var form = input.closest('form');
    if (!form) return;

    var isMin = !!input.closest('.collection-filters__filter-range--from');
    var slider = form.querySelector(isMin ? '[data-price-range-input="min"]' : '[data-price-range-input="max"]');
    if (!slider) return;

    slider.value = input.value === '' ? (isMin ? slider.min : slider.max) : input.value;
    this.syncPriceRangeSlider(slider);
  };

  Controller.prototype.syncNumericRangeSlider = function (slider) {
    var form = slider.closest('form');
    if (!form) return;

    var minSlider = form.querySelector('[data-numeric-range-input="min"]');
    var maxSlider = form.querySelector('[data-numeric-range-input="max"]');
    if (!minSlider || !maxSlider) return;

    var minVal = Number(minSlider.value);
    var maxVal = Number(maxSlider.value);

    if (slider === minSlider && minVal > maxVal) {
      minVal = maxVal;
      minSlider.value = minVal;
    } else if (slider === maxSlider && maxVal < minVal) {
      maxVal = minVal;
      maxSlider.value = maxVal;
    }

    var values = form.querySelectorAll('[data-numeric-range-value]');
    var isFullRange = minVal === 0 && maxVal === values.length - 1;
    for (var i = 0; i < values.length; i++) {
      values[i].checked = !isFullRange && i >= minVal && i <= maxVal;
    }

    var fill = form.querySelector('[data-numeric-range-fill]');
    var span = values.length - 1;
    if (fill && span > 0) {
      fill.style.setProperty('--range-min-pct', (minVal / span) * 100 + '%');
      fill.style.setProperty('--range-max-pct', (maxVal / span) * 100 + '%');
    }

    var minLabel = form.querySelector('[data-numeric-range-label="min"]');
    var maxLabel = form.querySelector('[data-numeric-range-label="max"]');
    if (minLabel && values[minVal]) minLabel.textContent = values[minVal].dataset.rangeLabel;
    if (maxLabel && values[maxVal]) maxLabel.textContent = values[maxVal].dataset.rangeLabel;
  };

  Controller.prototype.onClick = function (event) {
    var filterLink = event.target.closest ? event.target.closest('[data-filter-input]') : null;
    if (filterLink && filterLink.tagName === 'A' && filterLink.href) {
      event.preventDefault();
      var optimisticItem = this.applyOptimisticCheck(filterLink);
      this.renderFilters(filterLink.href, false, optimisticItem);
      return;
    }

    var drawerTrigger = event.target.closest ? event.target.closest('[data-productgrid-trigger-filters]') : null;
    if (drawerTrigger) {
      this.toggleDrawer();
      return;
    }

    var closeTrigger = event.target.closest ? event.target.closest('[data-productgrid-close-filters]') : null;
    if (closeTrigger) {
      this.closeDrawer();
      return;
    }

    var backdrop = event.target.closest ? event.target.closest('[data-productgrid-sidebar-backdrop]') : null;
    if (backdrop) {
      this.closeDrawer();
    }
  };

  Controller.prototype.onSubmit = function (event) {
    var form = event.target.closest
      ? event.target.closest('.collection-filters__price-range-form, .collection-filters__numeric-range-form')
      : null;
    if (!form) return;
    event.preventDefault();

    var url = new URL(window.location.href);
    var rangeValues = form.querySelectorAll('[data-numeric-range-value]');
    if (rangeValues.length) {
      url.searchParams.delete(rangeValues[0].name);
      for (var rangeIndex = 0; rangeIndex < rangeValues.length; rangeIndex++) {
        if (rangeValues[rangeIndex].checked) {
          url.searchParams.append(rangeValues[rangeIndex].name, rangeValues[rangeIndex].value);
        }
      }
      this.renderFilters(url.toString());
      return;
    }

    var inputs = form.querySelectorAll('[data-filter-range]');
    for (var i = 0; i < inputs.length; i++) {
      var input = inputs[i];
      if (input.value) {
        url.searchParams.set(input.name, input.value);
      } else {
        url.searchParams.delete(input.name);
      }
    }
    this.renderFilters(url.toString());
  };

  Controller.prototype.onPopState = function () {
    this.renderFilters(window.location.href, true);
  };

  Controller.prototype.onKeydown = function (event) {
    if (event.key === 'Escape' && this.sidebarOpen) this.closeDrawer();
  };

  Controller.prototype.applyOptimisticCheck = function (link) {
    var item = link.closest('.collection-filters__filter-list-item');
    if (!item) return null;
    item.classList.toggle('collection-filters__filter-list-item--active');
    return item;
  };

  Controller.prototype.toggleDrawer = function () {
    if (this.sidebarOpen) {
      this.closeDrawer();
    } else {
      this.openDrawer();
    }
  };

  Controller.prototype.openDrawer = function () {
    var drawer = this.outer.querySelector('[data-productgrid-sidebar-drawer]');
    var backdrop = this.outer.querySelector('[data-productgrid-sidebar-backdrop]');
    var trigger = this.outer.querySelector('[data-productgrid-trigger-filters]');
    if (!drawer) return;

    drawer.setAttribute('data-drawer-open', '');
    if (backdrop) backdrop.setAttribute('data-backdrop-open', '');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    this.bodyOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    this.sidebarOpen = true;
  };

  Controller.prototype.closeDrawer = function () {
    var drawer = this.outer.querySelector('[data-productgrid-sidebar-drawer]');
    var backdrop = this.outer.querySelector('[data-productgrid-sidebar-backdrop]');
    var trigger = this.outer.querySelector('[data-productgrid-trigger-filters]');
    if (drawer) drawer.removeAttribute('data-drawer-open');
    if (backdrop) backdrop.removeAttribute('data-backdrop-open');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = this.bodyOverflow;
    this.sidebarOpen = false;
  };

  Controller.prototype.setBusy = function (busy) {
    var form = this.outer.querySelector('facet-filters-form');
    var grid = this.outer.querySelector('#ProductGridContainer');
    var drawer = this.outer.querySelector('[data-productgrid-sidebar-drawer]');
    var drawerContent = drawer ? drawer.querySelector('[data-productgrid-sidebar]') : null;

    this.outer.setAttribute('aria-busy', busy ? 'true' : 'false');
    if (grid) grid.setAttribute('aria-busy', busy ? 'true' : 'false');
    if (drawer) drawer.setAttribute('aria-busy', busy ? 'true' : 'false');

    [form, drawerContent].forEach(function (region) {
      if (!region) return;
      if (busy) {
        region.setAttribute('inert', '');
      } else {
        region.removeAttribute('inert');
      }
    });
  };

  Controller.prototype.renderFilters = function (url, isPopState, optimisticItem) {
    var self = this;

    if (this.activeRequest) this.activeRequest.abort();
    var controller = new AbortController();
    this.activeRequest = controller;

    function resetOptimisticItem() {
      if (optimisticItem && optimisticItem.isConnected) {
        optimisticItem.classList.toggle('collection-filters__filter-list-item--active');
      }
      optimisticItem = null;
    }

    var requestTimeout = window.setTimeout(function () {
      controller.abort();
      resetOptimisticItem();
      if (self.activeRequest !== controller) return;
      self.activeRequest = null;
      self.setBusy(false);
    }, REQUEST_TIMEOUT_MS);

    this.setBusy(true);

    var fetchUrl = new URL(url, window.location.origin);
    fetchUrl.hash = '';
    fetchUrl.searchParams.set('section_id', this.sectionId);

    fetch(fetchUrl.toString(), { signal: controller.signal })
      .then(function (response) {
        if (!response.ok) throw new Error('Facet request failed');
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        if (!self.swap(doc)) throw new Error('Facet response was incomplete');
        if (!isPopState) history.pushState({ facetFilters: true }, '', url);
      })
      .catch(function () {
        resetOptimisticItem();
      })
      .finally(function () {
        window.clearTimeout(requestTimeout);
        if (self.activeRequest !== controller) return;
        self.activeRequest = null;
        self.setBusy(false);
      });
  };

  Controller.prototype.swap = function (doc) {
    if (!doc.querySelector('#product-grid')) return false;

    for (var i = 0; i < SWAP_SELECTORS.length; i++) {
      var selector = SWAP_SELECTORS[i];
      var current = this.outer.querySelector(selector);
      var next = doc.querySelector(selector);
      if (current && next) current.outerHTML = next.outerHTML;
    }

    if (this.sidebarOpen) {
      var drawer = this.outer.querySelector('[data-productgrid-sidebar-drawer]');
      var backdrop = this.outer.querySelector('[data-productgrid-sidebar-backdrop]');
      var trigger = this.outer.querySelector('[data-productgrid-trigger-filters]');
      if (drawer) drawer.setAttribute('data-drawer-open', '');
      if (backdrop) backdrop.setAttribute('data-backdrop-open', '');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
    }

    return true;
  };

  function init() {
    var outers = document.querySelectorAll('[data-productgrid-outer]');
    outers.forEach(function (outer) {
      if (outer.dataset.facetFiltersInit) return;
      if (!outer.querySelector('facet-filters-form')) return;
      outer.dataset.facetFiltersInit = '1';
      new Controller(outer);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
